import React, { useState } from "react";
import { Modal, Form, Dropdown } from "react-bootstrap";
import { Formik, Field, Form as FormikForm } from "formik";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { createTemplates } from "../../../store/whatsApp/wpThunks";
const FormTemplate = ({ FormatSelect, Selectedtemplatename }) => {
  const [selectedOption, setSelectedOption] = useState("None");
  const [variableError, setVariableError] = useState("");
  const inputRef = useRef(null);
  const initialValues = {
    name: Selectedtemplatename,
    body: FormatSelect
      ? FormatSelect.find((item) => item.type === "BODY")?.text || ""
      : "",
    footer: FormatSelect
      ? FormatSelect.find((item) => item.type === "FOOTER")?.text || ""
      : "",
    text: FormatSelect
      ? FormatSelect.find((item) => item.type === "HEADER")?.text || ""
      : "",
    file: null,
    selectedOption: FormatSelect
      ? FormatSelect.find((item) => item.type === "HEADER")?.format || "None"
      : "None",
  };
  let dispatch = useDispatch()
  const handleSelect = (eventKey) => {
    setSelectedOption(eventKey);
  };

  const handleValidateBody = (bodyText) => {
    const variables = (bodyText.match(/{{\d+}}/g) || []).length;
    if (variables > 30) {
      setVariableError("You cannot have more than 30 variables in the body.");
    } else {
      setVariableError("");
    }
  };

  return (
    <Modal.Body>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          let template;

          if (
            values?.body !== "" &&
            values?.footer !== "" &&
            values?.selectedOption !== "None"
          ) {
            template = {
              name: values?.name,
              language: "en_US",
              category: "UTILITY",
              components: [
                {
                  type: "HEADER",
                  format: values?.selectedOption,
                  text: "We value your feedback!",
                },
                {
                  type: "BODY",
                  text: values?.body,
                  example: {
                    body_text: [["Mark", "860198-230332"]],
                  },
                },
                {
                  type: "FOOTER",
                  text: values?.footer,
                },
              ],
            };

            // Additional logic for using the `template` object can go here.
          } else if (
            values?.body !== "" &&
            values?.footer !== "" &&
            values?.selectedOption === "None"
          ) {
            template = {
              name: values?.name,
              language: "en_US",
              category: "UTILITY",
              components: [

                {
                  type: "BODY",
                  text: values?.body,
                  example: {
                    body_text: [["Mark", "860198-230332"]],
                  },
                },
                {
                  type: "FOOTER",
                  text: values?.footer,
                },
              ],
            };
          }
          else if (values?.body !== "" &&
            values?.footer === "" &&
            values?.selectedOption === "None") {
            template = {
              name: values?.name,
              language: "en_US",
              category: "UTILITY",
              components: [

                {
                  type: "BODY",
                  text: values?.body,
                  example: {
                    body_text: [["Mark", "860198-230332"]],
                  },
                },

              ],
            };
          }
          else if (values?.body !== "" && values?.footer == "" && values?.footer !== "None") {
            template = {
              name: values?.name,
              language: "en_US",
              category: "UTILITY",
              components: [
                {
                  type: "HEADER",
                  format: values?.selectedOption,
                  text: "We value your feedback!",
                },
                {
                  type: "BODY",
                  text: values?.body,
                  example: {
                    body_text: [["Mark", "860198-230332"]],
                  },
                },

              ],
            };
          }
          console.log("template:", template);
          dispatch(createTemplates(template)).then((resp) => {
            console.log("resp- createTemplates:", resp);

          }).catch((e) => {
            console.log("Error-createTemplates:", e);
          })
        }}

      >
        {({ setFieldValue, values }) => (
          <FormikForm>
            <Form.Group className="form-group">
              <Form.Label>Name</Form.Label>
              <Field
                className="form-control"
                type="text"
                name="name"
                placeholder="Enter text"
              />
            </Form.Group>
            <Form.Group className="form-group">
              <Form.Label>
                <b>Header</b>· Optional
              </Form.Label>
              <Dropdown
                onSelect={(eventKey) =>
                  setFieldValue("selectedOption", eventKey)
                }
              >
                <Dropdown.Toggle
                  variant="outline-secondary"
                  id="dropdown-basic"
                  style={{ width: "100%", textAlign: "left" }}
                >
                  {values.selectedOption}
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ width: "100%" }}>
                  {["None", "TEXT", "IMAGE", "Video", "Document"].map(
                    (option) => (
                      <Dropdown.Item eventKey={option} key={option}>
                        <label>
                          <input
                            type="radio"
                            name="header-option"
                            value={option}
                            checked={values.selectedOption === option}
                            onChange={() =>
                              setFieldValue("selectedOption", option)
                            }
                            style={{ marginRight: "8px" }}
                          />
                          {option}
                        </label>
                      </Dropdown.Item>
                    )
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </Form.Group>

            {values.selectedOption === "TEXT" && (
              <Form.Group className="form-group">
                <Form.Label>Text</Form.Label>
                <Field
                  className="form-control"
                  type="text"
                  name="text"
                  placeholder="Enter text"
                />
              </Form.Group>
            )}

            {(values.selectedOption === "IMAGE" ||
              values.selectedOption === "Video" ||
              values.selectedOption === "Document") && (
                <Form.Group className="form-group">
                  <Form.Label>{values.selectedOption}</Form.Label>
                  <div>
                    <p>
                      To help us review your content, provide examples of the
                      variables or media in the header. Do not include any
                      customer information. Cloud API hosted by Meta reviews
                      templates and variable parameters to protect the security
                      and integrity of our services.
                    </p>
                    <input
                      className="form-control"
                      type="file"
                      onChange={(event) =>
                        setFieldValue("file", event.currentTarget.files[0])
                      }
                    />
                  </div>
                </Form.Group>
              )}

            {/* Body Field with Variables */}
            <Form.Group>
              <Form.Label>Body</Form.Label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Field
                  as="textarea"
                  className="form-control"
                  rows={3}
                  name="body"
                  ref={inputRef}
                  placeholder="Enter text with {{variables}}"
                  onChange={(e) => {
                    const value = e.target.value;

                    // Automatically renumber variables on input change
                    const updatedText = value.replace(
                      /{{\d+}}/g,
                      (_, i, str) => {
                        // Create an array of current variable matches
                        const allVariables = Array.from(
                          str.matchAll(/{{\d+}}/g),
                          (match) => match[0]
                        );
                        return `{{${allVariables.indexOf(_) + 1}}}`;
                      }
                    );
                    setFieldValue("body", updatedText);

                    handleValidateBody(updatedText);
                  }}
                  value={values.body}
                  style={{ flex: 1 }}
                />
              </div>
              <button
                type="button"
                className="btn btn-transparent text-[#000] ms-2 mt-[15px]"
                onClick={() => {
                  const currentText = values.body || "";
                  const variableCount =
                    (currentText.match(/{{\d+}}/g) || []).length + 1;
                  const newText = `${currentText} {{${variableCount}}}`;
                  setFieldValue("body", newText);
                  handleValidateBody(newText);
                }}
              >
                + Add Variable
              </button>
              {variableError && (
                <p style={{ color: "red", fontSize: "0.9em" }}>
                  {variableError}
                </p>
              )}
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Label className="my-3">
                <b>Footer</b>· Optional
              </Form.Label>
              <Field
                className="form-control"
                type="text"
                name="footer"
                placeholder="Enter text"
              />
            </Form.Group>

            <button type="submit" className="btn btn-primary mt-3">
              Submit
            </button>
          </FormikForm>
        )}
      </Formik>
    </Modal.Body>
  );
};

export default FormTemplate;
